export interface GeoLocation {
  lat: number;
  lng: number;
}

export enum ProfileType {
  CAR = 0,
  TRUCK = 1
}

export enum TransportType {
  AIR = 'air',
  SEA = 'sea'
}

export type HighlightAggregatorMarker = {
  aggregatorIds: string[];
  markerSelectedId: string;
};

export interface StructuralAggregatorMapbox {
  areaDataIds: string[];
  color: string;
  id: number;
  name: string;
  orderedMarkerIds: number[];
  profile: ProfileType;
  routeVisibility: boolean;
  solutionType: string;
  weight: number;
}
